/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUniverseConstellationsConstellationIdPosition } from './GetUniverseConstellationsConstellationIdPosition';
import {
    GetUniverseConstellationsConstellationIdPositionFromJSON,
    GetUniverseConstellationsConstellationIdPositionFromJSONTyped,
    GetUniverseConstellationsConstellationIdPositionToJSON,
    GetUniverseConstellationsConstellationIdPositionToJSONTyped,
} from './GetUniverseConstellationsConstellationIdPosition';

/**
 * 200 ok object
 * @export
 * @interface GetUniverseConstellationsConstellationIdOk
 */
export interface GetUniverseConstellationsConstellationIdOk {
    /**
     * constellation_id integer
     * @type {number}
     * @memberof GetUniverseConstellationsConstellationIdOk
     */
    constellationId: number;
    /**
     * name string
     * @type {string}
     * @memberof GetUniverseConstellationsConstellationIdOk
     */
    name: string;
    /**
     * 
     * @type {GetUniverseConstellationsConstellationIdPosition}
     * @memberof GetUniverseConstellationsConstellationIdOk
     */
    position: GetUniverseConstellationsConstellationIdPosition;
    /**
     * The region this constellation is in
     * @type {number}
     * @memberof GetUniverseConstellationsConstellationIdOk
     */
    regionId: number;
    /**
     * systems array
     * @type {Array<number>}
     * @memberof GetUniverseConstellationsConstellationIdOk
     */
    systems: Array<number>;
}

/**
 * Check if a given object implements the GetUniverseConstellationsConstellationIdOk interface.
 */
export function instanceOfGetUniverseConstellationsConstellationIdOk(value: object): value is GetUniverseConstellationsConstellationIdOk {
    if (!('constellationId' in value) || value['constellationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('regionId' in value) || value['regionId'] === undefined) return false;
    if (!('systems' in value) || value['systems'] === undefined) return false;
    return true;
}

export function GetUniverseConstellationsConstellationIdOkFromJSON(json: any): GetUniverseConstellationsConstellationIdOk {
    return GetUniverseConstellationsConstellationIdOkFromJSONTyped(json, false);
}

export function GetUniverseConstellationsConstellationIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseConstellationsConstellationIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'constellationId': json['constellation_id'],
        'name': json['name'],
        'position': GetUniverseConstellationsConstellationIdPositionFromJSON(json['position']),
        'regionId': json['region_id'],
        'systems': json['systems'],
    };
}

export function GetUniverseConstellationsConstellationIdOkToJSON(json: any): GetUniverseConstellationsConstellationIdOk {
    return GetUniverseConstellationsConstellationIdOkToJSONTyped(json, false);
}

export function GetUniverseConstellationsConstellationIdOkToJSONTyped(value?: GetUniverseConstellationsConstellationIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'constellation_id': value['constellationId'],
        'name': value['name'],
        'position': GetUniverseConstellationsConstellationIdPositionToJSON(value['position']),
        'region_id': value['regionId'],
        'systems': value['systems'],
    };
}

